import { render, staticRenderFns } from "./TutorialDoll.vue?vue&type=template&id=03bce004&scoped=true&"
import script from "./TutorialDoll.vue?vue&type=script&lang=js&"
export * from "./TutorialDoll.vue?vue&type=script&lang=js&"
import style0 from "./TutorialDoll.vue?vue&type=style&index=0&id=03bce004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bce004",
  null
  
)

export default component.exports